module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('iframe', {
    attrs: {
      "src": "http://pre.bpm.imfbp.com/ubpm-web-process-center2-2.0/index?code=TGT-30b6be2159c3f62c9f17bf60dfb4bdb0d41a2f3233de6caa8c9c0ca946cd47bf&tgt=4B7C7620AF70462391786F97875158F4#/bpmmanage/processcategory/list",
      "width": "100%",
      "height": "100%"
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-06d7f2c9"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/bmp/index.vue
// module id = 500
// module chunks = 1